import { render, staticRenderFns } from "./ResellerInvoiceViewDetails.vue?vue&type=template&id=4bb7f955"
import script from "./ResellerInvoiceViewDetails.vue?vue&type=script&lang=js"
export * from "./ResellerInvoiceViewDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports